
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton } from "office-ui-fabric-react";

const ToolbarLinkButtons = ({
    items
}) => {

    return (
        <Stack tokens={{childrenGap: '5px'}} horizontal>
            {items.map((item, index) => {

                const handleClick = () => {
                    if (item.onClick) {
                        item.onClick(item);
                    }
                }

                return (
                    <DefaultButton styles={{root: {width: '100%', maxWidth: '338px'}}} key={index} onClick={handleClick}>{item.title}</DefaultButton>
                );
            })}
        </Stack>
    );
}

export default ToolbarLinkButtons;
